import React, { useState } from "react";
import { toast } from "react-toastify";

const EnterOtpPage = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1);
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleSubmit = () => {
    toast.error(`Entered OTP: ${otp.join("")}`);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#FAF9F8",
        border: "1px solid #00000033",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#FFFFFF",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "400px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontFamily: "Inter",
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "10px",
          }}
        >
          Enter OTP
        </h2>
        <p
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            color: "#6B7280",
            marginBottom: "20px",
          }}
        >
          We’ve sent a 6-digit code to your registered mobile number.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleOtpChange(e, index)}
              style={{
                width: "40px",
                padding: "10px",
                fontSize: "18px",
                textAlign: "center",
                borderRadius: "4px",
                border: "1px solid #D1D5DB",
              }}
            />
          ))}
        </div>
        <button
          onClick={handleSubmit}
          style={{
            width: "300px",
            height: "54px",
            padding: "20px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#FFFFFF",
            background: "#000000",
            borderRadius: "5px 0px 0px 0px",
            cursor: "pointer",
            opacity: "1",
          }}
        >
          Submit OTP
        </button>

        <p
          style={{
            marginTop: "10px",
            fontSize: "14px",
            color: "#6B7280",
          }}
        >
          Didn’t receive the code?
          <span
            style={{
              color: "#000000",
              cursor: "pointer",
            }}
            // onClick={() => alert("Resend OTP clicked")}
          >
            Resend OTP
          </span>
        </p>
      </div>
    </div>
  );
};

export default EnterOtpPage;
